import React from 'react'
import { ShowButton, TopToolbar, useGetIdentity, useRedirect } from 'react-admin'

const MailServiceConfigEditActions = () => {

  const redirect = useRedirect()
  const { data: identity, isLoading } = useGetIdentity()
  if(isLoading || !identity) return null

  return (
    <TopToolbar>
      <ShowButton onClick={(e) => {
        e.preventDefault()
        redirect(`/users/${identity.id}/mailServiceConfig`)
      }}/>
    </TopToolbar>
  )
}

export default MailServiceConfigEditActions